module.exports = __webpack_public_path__ + "img/white-cam-card.a30500b1.png";